import React, { useEffect, useState } from "react";
import { RingLoader } from "react-spinners";
import { alert_error, alert_success } from "../../AppContext.js";
import Getlink from './Getlink';
import { Helmet } from "react-helmet";
import Getinfotask from './infotask_get.jsx';
import Editinfotask from './infotask_edit.jsx';
import axios from "axios";
import { useParams } from "react-router-dom";
import { FiEdit } from "react-icons/fi";
import { Cookies } from '../../index.js';

function Faucettraffic() {
    const myCookieValue = Cookies.get('apikey');
    const [reloadInfo, setReloadInfo] = useState(false);
    const { slug_2 } = useParams();
    console.log(slug_2); // In ra: 0986565156
    const [item, setitem] = useState('');
    const [showinfo, setshowinfo] = useState(false);
    const [level, setlevel] = useState('');
    const [showedit, setshowedit] = useState(false);
    const [options, setoptions] = useState([
        {
            id: '79132', stt: '', name: 'Please wait a moment 😊',
            money: '10000', status: 'show', content: 'ssss', servicecode: ''
        }
    ]);
    function laydulieujop() {
        axios.get('https://hust.media/jop/mission/infotask.php?idinfo=' + slug_2 + '&apikey=' + myCookieValue)
            .then(response => {
                setitem(response.data);
                setReloadInfo(prevValue => !prevValue);
                setshowinfo(true);
                if (response.data.level) {
                    setlevel(response.data.level);
                }
            })
            .catch(error => {
                console.error(error);
            });
    };
    function edit() {
        if (level != 'editor') {
            alert_error('User chỉnh sửa mới được chỉnh thông số');
        }
        else {
            setshowedit(true);
        }
    };
    function loadinfo() {
        setshowinfo(false);
        // Đặt giá trị mới cho reloadInfo để gửi sự thay đổi đến component con
        laydulieujop();
    };
    useEffect(() => {
        laydulieujop();
    }, []);
    return (
        <>
            {!showinfo ? (<div className="flex justify-center items-center">
                <RingLoader size={80} color="#0000ff" />{" "}
            </div>
            ) : (<>
                <Editinfotask item={item} showedit={showedit} setshowedit={setshowedit} loadinfo={loadinfo} options={options} />
                <Getinfotask item={item} edit={edit} key={reloadInfo} options={options} setoptions={setoptions} />
            </>)}
        </>
    );
}

export default Faucettraffic;
